import React, {
  useState,
  useEffect
} from 'react';
import {
  makeStyles,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import Player from './Player';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  galeria: {
    marginTop: '32px'
  },
  imagem: {
    display: 'block',
    maxWidth: '100%',
    margin: '0 auto',
  },
  title: {
    backgroundColor: 'transparent',
    '& h2': {
      color: 'white',
      fontSize: '39px',
      fontFamily: 'Roboto',
      fontWeight: 700,
    },
  },
  button: {
    color: 'white',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
  },
  confirmar: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    background: '#51B36E',
    '&:hover': {
      backgroundColor: '#51B36E',
    }
  },
  direita: {
    textAlign: 'right'
  },
  play: {
    color: '#3E3E3E',
    fontSize: '20px'
  },
  remover: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    color: '#808080',
    textAlign: 'center',
    maxWidth: '290px',
    margin: '15px auto'
  },
  removerholder: {
    overflowY: 'unset',
    textAlign: 'center',
    padding: '24px'
  },
  sim: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    margin: '5px 15px',
    background: '#C03A2A',
    '&:hover': {
      backgroundColor: '#C03A2A',
    },
    maxWidth: '112px'
  },
  nao: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    margin: '5px 15px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    background: '#808080',
    '&:hover': {
      backgroundColor: '#808080',
    },
    maxWidth: '112px'
  },
  card: {
    backgroundColor: 'rgba(0, 0, 0, .75)',
    '& .MuiPaper-root': {
      backgroundColor: 'rgba(0, 0, 0, .75)',
    }
  }
}));
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: '#ffffff',
  },
  dropzone: {
    margin: '0px 0px 10px 0px',
    width: '100%'
  },
  titulo: {
    fontSize: '39px'
  }
});
const DialogTitle = withStyles(styles)((props) => {
  const {
    children,
    classes,
    onClose,
    ...other
  } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography className={classes.titulo} variant="h2">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const ViewArquivo = (props) => {
  const { anexo, onClose, open } = props;
  const [preview, setPreview] = useState(<></>);
  const [nome, setNome] = useState(<></>);
  const classes = useStyles();
  useEffect(() => {
    if (anexo !== undefined && anexo !== false && anexo !== null) {
      const tipo = anexo.tipo.split('/')[0];
      setNome(anexo.original.split('.')[0]);
      switch (tipo) {
        case 'image':
          setPreview(
            <img src={`${process.env.REACT_APP_BACKEND_IMG}${anexo.caminho}`} className={classes.imagem} alt={anexo.original} />
          );
          break;
        case 'audio':
          try {
            setPreview(
              <div>
                <Player
                  anexo={anexo}
                  playing
                  width={0}
                  height={0}
                />
              </div>
            );
          } catch (error) {
            console.log(error);
          }
          break;
        case 'video':
          try {
            setPreview(
              <div>
                <Player
                  anexo={anexo}
                  playing
                />
              </div>
            );
          } catch (error) {
            console.log(error);
          }
          break;
        default:
          break;
      }
    }
  }, [anexo]);
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        scroll="body"
        fullWidth
        maxWidth="md"
        className={classes.card}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={onClose}
          className={classes.title}
        >
          {nome}
        </DialogTitle>
        <DialogContent dividers>
          {preview}
        </DialogContent>
      </Dialog>
    </>
  );
};
export default ViewArquivo;
